module.exports = __webpack_public_path__ + "mastercard-icon.png?82e3feccfa860955071cb58959167f37";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mastercard-icon.png
// module id = 1040
// module chunks = 0